import React from 'react';

import { Icon } from '~/eds/src/components/Icon/Icon';
import { IconButton } from '~/eds/src/components/IconButton/IconButton';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { useIntl } from 'react-intl';
import Text from '~/ui/components/Text/Text';
import { HandlerName } from '~/utils/table';

const RestrictedName = () => {
  const intl = useIntl();
  return (
    <>
      <Icon
        icon="file"
        label={intl.formatMessage({
          id: 'NameCell.fileLabel',
          defaultMessage: 'File',
          description: 'Label for file icon in restricted name',
        })}
      />
      <Text>
        {intl.formatMessage({
          id: 'NameCell.restrictedFileText',
          defaultMessage: 'Restricted File',
          description: 'Text shown for restricted file name',
        })}
      </Text>
    </>
  );
};

export const NameCell = ({
  document,
  openTarget = null,
  onClick,
  onCollapse,
  onExpand,
  indent,
  isExpanded,
}) => {
  const intl = useIntl();
  const isRestricted = !document.document_id;
  const hasChildren = !!document.number_of_children;
  const toggle = isExpanded ? onCollapse : onExpand;

  return (
    <Layout
      pl={(indent - 1) * 40}
      spacing={4}
      styles={{ maxWidth: '100%' }}
      flex="1 0"
    >
      {hasChildren && (
        <IconButton
          text={intl.formatMessage({
            id: 'NameCell.toggleCollapse',
            defaultMessage: 'Toggle collapse',
            description: 'Button label for toggling collapse/expand',
          })}
          icon={isExpanded ? 'caret-down' : 'caret-right'}
          onClick={() => toggle(document)}
        />
      )}
      <Layout
        align="center"
        spacing={1}
        pl={hasChildren ? 0 : 40}
        styles={{ maxWidth: 'calc(100% - 40px)' }}
      >
        {isRestricted ? (
          <RestrictedName />
        ) : (
          <HandlerName
            handlers={document.handlers}
            openTarget={openTarget}
            onClick={() => onClick(document)}
          />
        )}
      </Layout>
    </Layout>
  );
};
